export default function handleSquarePosition(position, styles) {
  switch (position) {
    case "top-left":
      return styles._top_left;
    case "top-right":
      return styles._top_right;
    case "bottom-right":
      return styles._bottom_right;
    case "bottom-left":
      return "";
  }
}
